/* ═══════════════════════════════════════════════════════════════════════════
   Koje okruzenje gleda korisnik.

   VAZNO o NODE_ENV-u: Create React App NE cita `NODE_ENV` iz `.env` fajlova —
   react-scripts ga postavlja sam, i to po komandi, ne po fajlu:

       npm start        -> development
       npm run build    -> production
       npm test         -> test

   Zato se TESTNO okruzenje koje se DEPLOYUJE (dakle pravi se `npm run build`)
   ne moze prepoznati po NODE_ENV-u — tamo on uvek pise 'production'. Da se traka
   oslanja samo na njega, na test serveru je nikad ne bismo videli, a bas tamo je
   i potrebna.

   Zato postoji `REACT_APP_OKRUZENJE`: nju CRA cita iz `.env` kao i svaku drugu
   promenljivu sa `REACT_APP_` prefiksom. Kad nije postavljena, pada se na
   NODE_ENV — pa razvojni server i dalje sam prikaze traku, bez ikakvog podesavanja.

   Podesavanje:
     razvoj          nista (NODE_ENV = development)
     test server     REACT_APP_OKRUZENJE=test        u .env.production tog servera
     produkcija      REACT_APP_OKRUZENJE=production  ili izostaviti
   ═══════════════════════════════════════════════════════════════════════════ */

const OKRUZENJE = (process.env.REACT_APP_OKRUZENJE || process.env.NODE_ENV || '').trim();

/* Sve sto nije izricito 'production' smatra se testnim — bolje je da se traka
   pojavi gde ne treba nego da izostane na test serveru i neko pomisli da radi
   nad pravim podacima. */
export const jeTestnoOkruzenje = OKRUZENJE !== 'production';

export default jeTestnoOkruzenje;
